import {DaoGeneric, ListParameters} from '@Services/base/daoService';
import {BehaviorSubject} from 'rxjs';
import {Pagination} from '@Common/widgets/general/pagination';
import {switchMap} from 'rxjs/operators';

export abstract class DaoGenericWithStorage<T> extends DaoGeneric<T> {
  private _storage: BehaviorSubject<Pagination> = new BehaviorSubject(<Pagination>{total: 0});
  private _refreshStorage = true;

  listAllItemsStored(refresh= false) {
    if (refresh) {
      this._refreshStorage = true;
    }
    if (this._refreshStorage) {
      this._refreshStorage = false;
      this.listAllItems().pipe (
        switchMap( (res) => {
          this._storage.next(res);
          return this._storage.asObservable();
        })
      ).subscribe();
    }
    return this._storage.asObservable();
  }
}
